<template>
	<App title="Cluster Management">
		<div class="w-100 position-relative">
			<Block class="border-top border-secondary border-2 col-md-10 mx-auto">
				<template #header>
					<h3 class="block-title">Cluster Management</h3>
				</template>

				<!-- Cluster Management Form -->
				<div class="row">
					<div class="col-12">
						<div class="card border-0 ">
							<div class="card-header bg-light border-0">
								<h5 class="card-title mb-0">
									<i class="bi bi-diagram-3-fill text-secondary me-2"></i>
									Create New Cluster (Super-Station)
								</h5>
								<p class="card-text text-muted mb-0 mt-1">
									<small>Clusters serve as 'Super-Stations' that support multiple stations within their zones</small>
								</p>
							</div>
							<div class="card-body p-4">
								<Form ref="clusterForm" @submit="onClusterSubmit">
									<div class="row g-3">
										<!-- Country Selection -->
										<div class="col-12 col-md-6">
											<label for="clusterCountry" class="form-label text-dark fw-normal">
												<i class="bi bi-flag me-1"></i>Country *
											</label>
											<SelectField 
												id="clusterCountry" 
												v-model="clusterData.country" 
												name="country" 
												rules="required" 
												label="Country" 
												:options="country_options"
											/>
											
											
										</div>

										<!-- Region Selection -->
										<div class="col-12 col-md-6">
											<label for="clusterRegion" class="form-label text-dark fw-normal">
												<i class="bi bi-geo-alt me-1"></i>Region *
											</label>
											<SelectField 
												id="clusterRegion" 
												v-model="clusterData.region" 
												name="region" 
												rules="required" 
												label="Region" 
												:options="region_options"
												:disabled="!clusterData.country"
											>
												
											</SelectField>
										</div>

										<!-- State Selection -->
										<div class="col-12 col-md-6">
											<label for="clusterState" class="form-label text-dark fw-normal">
												<i class="bi bi-building me-1"></i>State *
											</label>
											<SelectField 
												id="clusterState" 
												v-model="clusterData.state" 
												name="state" 
												rules="required" 
												label="State" 
												:options="state_options"
												:disabled="!clusterData.region"
											>
												
											</SelectField>
										</div>

										<!-- Zone Selection -->
										<div class="col-12 col-md-6">
											<label for="clusterZone" class="form-label text-dark fw-normal">
												<i class="bi bi-map me-1"></i>Zone *
											</label>
											<SelectField 
												id="clusterZone" 
												v-model="clusterData.zone" 
												name="zone" 
												rules="required" 
												label="Zone" 
												:options="zone_options"
												:disabled="!clusterData.state"
											>
											
											</SelectField>
										</div>

										<!-- Cluster Name -->
										<div class="col-12 col-md-6">
											<label for="clusterName" class="form-label text-dark fw-normal">
												<i class="bi bi-diagram-3 me-1"></i>Cluster Name *
											</label>
											<InputField 
												id="clusterName" 
												v-model="clusterData.cluster" 
												name="cluster" 
												rules="required|min:3|max:50" 
												label="Cluster Name" 
												placeholder="Enter cluster name (e.g., Central Hub, North Station)..." 
											/>
										</div>	
										<!--Manager-->
										<div class="col-12 col-md-6">
											<label for="clusterManager" class="form-label text-dark fw-normal">
												<i class="bi bi-person-badge me-1"></i>Cluster Manager
											</label>
											<SelectField 
												id="clusterManager" 
												v-model="clusterData.manager" 
												name="manager" 
												label="Manager" 
												:options="manager_options"
											>
											</SelectField>
										</div>


										<!-- 
										<div class="col-12 col-md-6">
											<label for="clusterType" class="form-label text-dark fw-normal">
												<i class="bi bi-tags me-1"></i>Cluster Type *
											</label>
											<SelectField 
												id="clusterType" 
												v-model="clusterData.type" 
												name="clusterType" 
												rules="required" 
												label="Cluster Type" 
												:options="cluster_type_options"
											>
												<option value="super_station">Super Station</option>
												<option value="hub_station">Hub Station</option>
												<option value="distribution_center">Distribution Center</option>
												<option value="service_center">Service Center</option>
											</SelectField>
										</div>

									
										<div class="col-12 col-md-6">
											<label for="clusterManager" class="form-label text-dark fw-normal">
												<i class="bi bi-person-badge me-1"></i>Cluster Manager
											</label>
											<SelectField 
												id="clusterManager" 
												v-model="clusterData.manager" 
												name="manager" 
												label="Manager" 
												:options="manager_options"
											>
												<option value="">Select Manager (Optional)</option>
												<option v-for="manager in managers" :key="manager.id" :value="manager.id">
													{{ manager.name }} - {{ manager.email }}
												</option>
											</SelectField>
										</div>

										
										<div class="col-12 col-md-6">
											<label for="maxStations" class="form-label text-dark fw-normal">
												<i class="bi bi-hash me-1"></i>Maximum Stations Supported
											</label>
											<InputField 
												id="maxStations" 
												v-model="clusterData.maxStations" 
												name="maxStations" 
												type="number" 
												label="Maximum Stations" 
												placeholder="e.g., 25" 
												min="1"
												max="100"
											/>
										</div>

									
										<div class="col-12 col-md-6">
											<label for="clusterPhone" class="form-label text-dark fw-normal">
												<i class="bi bi-telephone me-1"></i>Contact Phone
											</label>
											<InputField 
												id="clusterPhone" 
												v-model="clusterData.phone" 
												name="phone" 
												label="Phone" 
												placeholder="Enter contact phone number..." 
											/>
										</div>

									
										<div class="col-12 col-md-6">
											<label for="clusterEmail" class="form-label text-dark fw-normal">
												<i class="bi bi-envelope me-1"></i>Contact Email
											</label>
											<InputField 
												id="clusterEmail" 
												v-model="clusterData.email" 
												name="email" 
												rules="email" 
												label="Email" 
												placeholder="Enter contact email address..." 
											/>
										</div>

										
										<div class="col-12">
											<label for="clusterAddress" class="form-label text-dark fw-normal">
												<i class="bi bi-geo-alt-fill me-1"></i>Address
											</label>
											<TextareaField 
												id="clusterAddress" 
												v-model="clusterData.address" 
												name="address" 
												label="Address" 
												placeholder="Enter cluster physical address..." 
												rows="2"
											/>
										</div>

								
										<div class="col-12 col-md-6">
											<label for="operatingHours" class="form-label text-dark fw-normal">
												<i class="bi bi-clock me-1"></i>Operating Hours
											</label>
											<InputField 
												id="operatingHours" 
												v-model="clusterData.operatingHours" 
												name="operatingHours" 
												label="Operating Hours" 
												placeholder="e.g., 24/7, 6:00 AM - 10:00 PM" 
											/>
										</div>

										
										<div class="col-12 col-md-6">
											<label for="clusterStatus" class="form-label text-dark fw-normal">
												<i class="bi bi-toggle-on me-1"></i>Status *
											</label>
											<SelectField 
												id="clusterStatus" 
												v-model="clusterData.status" 
												name="status" 
												rules="required" 
												label="Status" 
												:options="status_options"
											>
												<option value="active">Active</option>
												<option value="inactive">Inactive</option>
												<option value="under_construction">Under Construction</option>
												<option value="maintenance">Under Maintenance</option>
											</SelectField>
										</div>

										
										<div class="col-12">
											<label for="clusterDescription" class="form-label text-dark fw-normal">
												<i class="bi bi-card-text me-1"></i>Description
											</label>
											<TextareaField 
												id="clusterDescription" 
												v-model="clusterData.description" 
												name="description" 
												label="Description" 
												placeholder="Enter cluster description, services offered, or special notes..." 
												rows="3"
											/>
										</div>
									-->
										<!-- Form Buttons -->
										<div class="col-12">
											<div class="d-grid gap-2 d-md-flex justify-content-md-end pt-3">
												<button 
													type="button" 
													class="btn bg-danger text-white me-2 px-4" 
													:disabled="clusterLoading || clusterDone" 
													@click="clearClusterForm"
												>
													<i class="bi bi-x-circle me-1"></i>Clear
												</button>
												<Button 
													id="clusterAction" 
													type="submit" 
													:label="clusterLabels" 
													:loading="clusterLoading" 
													:done="clusterDone" 
													class="btn bg-secondary text-light px-4" 
													:disabled="checkClusterInput" 
												/>
											</div>
										</div>
									</div>
								</Form>
							</div>
						</div>
					</div>
				</div>
			</Block>

			<!-- Notification Area -->
			<div class="mt-9 position-absolute top-0 end-0">
				<NotivueKeyboard v-slot="{ containersTabIndex }">
					<Notivue v-slot="item" :containersTabIndex="containersTabIndex">
						<AppNotification :item="item" />
					</Notivue>
				</NotivueKeyboard>
			</div>
		</div>
	</App>
</template>

<script lang="ts">
import $ from 'jquery'
import { useConfirm } from '@/libs/useConfirm.ts'
import locations from '@/json/location.json'
import Swal from 'sweetalert2'
import Alert from '@/vue/components/Alert.vue'
import Block from '@/vue/components/Block.vue'
import Button from '@/vue/components/Button.vue'
import Form from '@/vue/components/Form.vue'
import InputField from '@/vue/components/InputField.vue'
import SelectField from '@/vue/components/SelectField.vue'
import TextareaField from '@/vue/components/TextareaField.vue'
import App from '@/vue/templates/App.vue'
import { ButtonLabel } from '@/vue/utils/Button'
import { Options as Select2Options } from 'select2'
import { Component, Ref, Vue, Watch, toNative } from 'vue-facing-decorator'
import { Notivue, push, materialTheme, NotivueKeyboard } from 'notivue'
import AppNotification from '@/vue/components/AppNotification.vue'


@Component({
	components: {
		App,
		Form,
		Alert,
		InputField,
		Button,
		Block,
		SelectField,
		TextareaField,
		Notivue,
		AppNotification,
		NotivueKeyboard
	},
})
class ClusterManagement extends Vue {
	confirm = useConfirm().confirm
	materialTheme = materialTheme

	// Cluster Form Data
	clusterLoading = false
	clusterDone = false
	clusterData = {
		country: '',
		region: '',
		state: '',
		zone: '',
		cluster: '',
		manager: '',
	}


	@Ref('clusterForm')
	readonly clusterForm!: InstanceType<typeof Form>

	// Computed Properties
	get country_options(): Select2Options {
		return {
			
			placeholder: 'Select Country',
			minimumResultsForSearch: Infinity,
			ajax: {
				method: 'get',
				url: this.route('country.ajax.select.country'),
			},

			//@ts-ignore
			templateResult: ({ id, title, text }) => (id ? $(`<span>${title}</span>`) : text),
			//@ts-ignore
			templateSelection: ({ id, title, text }) => (id ? $(`<span>${title}</span>`) : text),
		}
	}

	get region_options(): Select2Options {
		return {
			placeholder: 'Select Region',
			minimumResultsForSearch: Infinity,
			ajax: {
				method: 'get',
				url: this.route('region.ajax.select.region'),
			},

			//@ts-ignore
			templateResult: ({ id, name, text }) => (id ? $(`<span>${name}</span>`) : text),
			//@ts-ignore
			templateSelection: ({ id, name, text }) => (id ? $(`<span>${name}</span>`) : text),

		}
	}

	get state_options(): Select2Options {
		return {
			
			placeholder: 'Select State',
			minimumResultsForSearch: Infinity,
			ajax: {
				method: 'get',
				url: this.route('state.ajax.select.state'),
			},

			//@ts-ignore
			templateResult: ({ id, name, text }) => (id ? $(`<span>${name}</span>`) : text),
			//@ts-ignore
			templateSelection: ({ id, name, text }) => (id ? $(`<span>${name}</span>`) : text),
		}
	}

	get zone_options(): Select2Options {
		return {
			
			placeholder: 'Select Zone',
			minimumResultsForSearch: Infinity,
			ajax: {
				method: 'get',
				url: this.route('zone.ajax.select.zone'),
			},

			//@ts-ignore
			templateResult: ({ id, name, text }) => (id ? $(`<span>${name}</span>`) : text),
			//@ts-ignore
			templateSelection: ({ id, name, text }) => (id ? $(`<span>${name}</span>`) : text),
		}
	}

	get manager_options(): Select2Options {
		return {
			
			placeholder: 'Select Manager',
			minimumResultsForSearch: Infinity,
			ajax: {
				method: 'get',
				url: this.route('admin.ajax.select.admin'),
			},

			//@ts-ignore
			templateResult: ({ id, fullname,email, text }) => (id ? $(`<span>${fullname} &nbsp; (${email})</span>`) : text),
			//@ts-ignore
			templateSelection: ({ id, fullname,email, text }) => (id ? $(`<span>${fullname} &nbsp; (${email})</span>`) : text),
		}
	}



	get clusterLabels(): ButtonLabel {
		return {
			normal: 'Create Cluster',
			loading: 'Creating...',
			done: 'Created'
		}
	}

	get checkClusterInput(): boolean {
		return [
			this.clusterData.country, 
			this.clusterData.region, 
			this.clusterData.state, 
			this.clusterData.zone,
			this.clusterData.cluster,
			
		].some(field => field.toString().trim() === '')
	}

	// Methods
	clearClusterForm() {
		this.clusterData = {
			country: '',
			region: '',
			state: '',
			zone: '',
			cluster: '',
			manager:''
		
		}
		this.clusterForm.reset()
	}

	@Watch('clusterData.country')
	onClusterCountryChange() {
		this.clusterData.region = ''
		this.clusterData.state = ''
		this.clusterData.zone = ''
	}

	@Watch('clusterData.region')
	onClusterRegionChange() {
		this.clusterData.state = ''
		this.clusterData.zone = ''
	}

	@Watch('clusterData.state')
	onClusterStateChange() {
		this.clusterData.zone = ''
	}

	// Form Submission Methods
	async onClusterSubmit(payload: any) {
		this.clusterLoading = true
		
		this.$http
			.post(this.route('cluster.page.create'), payload)
			.then((response) => {
				Swal.fire({
					title: 'Success!',
					text: 'Cluster created successfully!',
					icon: 'success',
					confirmButtonText: 'OK'
				}).then(() => {
					this.clearClusterForm()
					this.clusterDone = false
					setTimeout(()=>{
						this.router.visit(this.route('cluster.page.group'))
					},3000)
				
				})	
			})
			.catch((e) => {
				push.error({
					title: 'Error',
					message: 'Unable to create cluster at this time. Please try again later.'
				})
				
			})
			.finally(() => (this.clusterLoading = false))
	}

	// Helper method for email validation
	
}

export default toNative(ClusterManagement)
</script>